// extracted by mini-css-extract-plugin
module.exports = {"appliedFilterDescription":"entityOwnerFilterDescription_appliedFilterDescription__m1Kny","filtername":"entityOwnerFilterDescription_filtername__1cqwP"};